module.exports = __webpack_public_path__ + "img/02-1.9b83eace.gif";